global.modules.set({
  async init(context) {
    $('form.shares', context).on('submit', function (e) {
      e.preventDefault();
      var thisForm = $(this);
      const formData = new FormData(thisForm[0]);
      $.ajax({
        url: thisForm.attr('action'),
        data: formData,
        method: thisForm.attr('method'),
        complete: null,
        beforeSend: null,
        success: function (data) {
          if (data && data.success) {
            if(data.url) {
              window.open(data.url);
            }
            if($(thisForm).parent().hasClass('modal__content')) {
              $('.popup').attr('hidden', true).trigger('hide').removeClass('active');
              $('body').removeClass('lock');
            }
          } else {
            global.showNotificationPopup(data.message, 'error');
          }
        }
      });
    });

    $('.share_iframe').on('click', function () {
      navigator.clipboard.writeText($(this).data('href'));
      global.showNotificationPopup('Iframe copied successfully', 'success');
    })
  }
})